import type { JSXElementConstructor } from 'react';
import { type DataGridProProps, GridLogicOperator, type GridColumnVisibilityModel } from '@mui/x-data-grid-pro';
import { FilterPanelCustom } from 'src/components/data-grid/filter-panel-custom';
import NbColumnsManagement, {
  type NbColumnsManagementProps,
} from '../../non-branded/data-grid/columns-management';
import { HEADER_H, ROW_H } from './grid-sx';

type GridConfigArgs = {
  apiRef: React.MutableRefObject<any>;
  panelSlotProps: Record<string, unknown>;
  defaultModel: GridColumnVisibilityModel;
  slotProps?: DataGridProProps['slotProps'];
};

/**
 * DataGridPro settings shared by both Campaign Leaks tables: sizes, no column menu, filtering and sorting done by
 * applyFilters / applySort on the rows passed to the grid, filter and columns panels of the Non Brand grids.
 */
export const campaignLeaksGridProps = ({ apiRef, panelSlotProps, defaultModel, slotProps }: GridConfigArgs) =>
  ({
    apiRef,
    rowHeight: ROW_H,
    columnHeaderHeight: HEADER_H,
    disableColumnMenu: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    disableRowSelectionOnClick: true,
    disableMultipleColumnsSorting: true,
    filterMode: 'server',
    sortingMode: 'server',
    sortingOrder: ['desc', 'asc'],
    pagination: true,
    pageSizeOptions: [10, 25, 50, 100],
    slots: {
      filterPanel: FilterPanelCustom,
      columnsManagement: NbColumnsManagement as JSXElementConstructor<any>,
    },
    slotProps: {
      ...panelSlotProps,
      filterPanel: {
        logicOperators: [GridLogicOperator.And],
        getColumnForNewFilter: (args: any) => (args ? args.columns[0].field : null),
      } as any,
      columnsManagement: { defaultModel } satisfies Partial<NbColumnsManagementProps> as any,
      ...slotProps,
    },
  }) satisfies Partial<DataGridProProps>;
